import type { RuleHandler } from "../types";
import { setIncludes } from "../setIncludes";

const checkAllSportsMustMatch: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  if (
    !setIncludes(
      new Set(requirementAttributes?.sports),
      new Set(context.selection.sports),
      requirementAttributes?.allSportsMustMatch || false,
    )
  ) {
    return false;
  }

  return true;
};

export { checkAllSportsMustMatch };
